<template>
  <div class="dblb-container" v-loading.fullscreen.lock="fullscreenLoading">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="车间">
              <el-select v-model="searchForm.factory" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option v-for="item in factoryList" v-if="item.brand===0||group.dBrand===0||group.dBrand===item.brand" :key="item.factory_id" :label="item.simple_name"  :value="item.factory_id" />
              </el-select>
            </el-form-item>
            <el-form-item label="打包状态">
              <el-select v-model="searchForm.type" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option label="缺件" :value="0" />
                <el-option label="完整" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item label="入库状态">
              <el-select v-model="searchForm.rktype" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option label="缺件" :value="0" />
                <el-option label="完整" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    label="生产单号"
                    width="120"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.produnum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span :style="scope.row.delname && scope.row.delname.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                        {{ scope.row.delname }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="部件数量"
                    width="130"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500">{{scope.row.comnum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="包装状态"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag size="mini" :disable-transitions="true" v-if="scope.row.packtime!==null&&scope.row.packtime!==''&&scope.row.packtime!==undefined">包装完整</el-tag>
                      <el-tag size="mini" :disable-transitions="true" type="danger" v-if="scope.row.packtime===null||scope.row.packtime===''||scope.row.packtime===undefined">缺件 {{scope.row.comnum-scope.row.packednum}}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="包装数量"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.packnum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="入库数量"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#67C23A">{{scope.row.inpacknum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="未入库数量"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#f56c6c">{{scope.row.packnum-scope.row.inpacknum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="160"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="分派工厂"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.factoryname}}</span>
                    </template>
                  </el-table-column>
                  <!--                  <el-table-column-->
                  <!--                    label="最近打包时间"-->
                  <!--                    width="170"-->
                  <!--                    show-overflow-tooltip>-->
                  <!--                    <template slot-scope="scope">-->
                  <!--                      <span v-if="scope.row.packnum>0"><i class="el-icon-time"></i> {{scope.row.time}}</span>-->
                  <!--                      <span v-if="scope.row.packnum===0" style="color:#99a9bf">未打包</span>-->
                  <!--                    </template>-->
                  <!--                  </el-table-column>-->
                  <el-table-column
                    label="操作"
                    width="150"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-button size="mini" @click="openPackDetails(scope.row)" icon="el-icon-tickets">包装详细</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="packTitle"
      :visible.sync="editVisible"
      width="60%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form size="small" ref="editForm" :inline="true" :model="editForm" :rules="editRules" label-width="60px">
        <el-form-item label="标签号" prop="packnum">
          <el-input v-model="editForm.packnum" maxlength="14" style="width: 130px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="包号" prop="xuhao">
          <el-input type="number" v-model="editForm.xuhao" style="width: 80px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="imark">
          <el-select v-model="editForm.imark" style="width: 100px" clearable>
            <el-option label="未入库" value="0"></el-option>
            <el-option label="已入库" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="searchPack" icon="el-icon-search">搜索</el-button>
          <el-button plain @click="batchUnpack" >批量入库</el-button>
        </el-form-item>
      </el-form>
      <div style="height: 400px;width: 100%" v-loading="packloading">
        <pl-table
          height="400px"
          :key="tableKey"
          :datas="packTableData"
          :data="packTableData"
          use-virtual
          :pagination-show="false"
          @selection-change="handleSelectionChange"
          size="small"
          :row-height="45">
          <pl-table-column type="selection" :selectable='checkboxT' align="center" width="50"></pl-table-column>
          <pl-table-column prop="packnum" :resizable="false" align="center" label="包标签号" show-overflow-tooltip width="130"></pl-table-column>
          <pl-table-column prop="xuhao" :resizable="false" align="center" label="包号" show-overflow-tooltip width="90"></pl-table-column>
          <pl-table-column prop="username" :resizable="false" align="center" label="打包人" show-overflow-tooltip width="100"></pl-table-column>
          <pl-table-column prop="time" :resizable="false" align="center" label="打包时间" show-overflow-tooltip min-width="130"></pl-table-column>
          <pl-table-column prop="num" :resizable="false" align="center" label="部件数量" show-overflow-tooltip width="90"></pl-table-column>
          <pl-table-column label="状态" :resizable="false" width="90" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" :disable-transitions="true" v-if="scope.row.imark===1">已入库</el-tag>
              <el-tag size="mini" :disable-transitions="true" type="danger" v-if="scope.row.imark===0">未入库</el-tag>
            </template>
          </pl-table-column>
          <!--<pl-table-column label="操作" :resizable="false" width="100" align="center">
            <template slot-scope="scope">
              <el-button v-if="scope.row.imark===0" size="mini" icon="el-icon-remove-outline" @click="unpack(scope.row)">拆包</el-button>
              <el-button v-if="scope.row.imark!==0" size="mini" icon="el-icon-remove-outline" :disabled="true">拆包</el-button>
            </template>
          </pl-table-column>-->
        </pl-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  getErpPackList,
  getErpOrderPackList,
  getErpOrderPackInfoList,
  packageInStock,
  getFactoryList,
  getGroupInfoByUser
} from '@/api/erp'

export default {
  name: 'plrk',
  computed: {
    user: getUser
  },
  data() {
    return {
      fullscreenLoading: false,
      packTitle: '',
      packInfoTitle: '',
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      editInfoVisible: false,
      packtypeList: [],
      editForm: {
        packnum: '',
        xuhao: '',
        orderid: '',
        produnum: '',
        imark: ''
      },
      editInfoForm: {
        orderid: '',
        area: '',
        type: '',
        content: '',
        packid: '',
        mmark: '',
        imark: ''
      },
      editRules: {
        ptid: [{ required: true, message: '请选择包装类型', trigger: 'change' }],
        produnum: [{ required: true, message: '请选择订单', trigger: 'change' }]
      },
      tableKey: '',
      multipleSelection: [],
      packTableData: [],
      packloading: false,
      tableInfoKey: '',
      multipleInfoSelection: [],
      packInfoTableData: [],
      packInfoloading: false,
      isfirst: false,
      areaList: [],
      typeList: [],
      packList: [],
      searchForm: {
        type: '',
        search: '',
        rktype: '',
        factory: ''
      },
      factoryList: [],
      group: {
        dBrand: 1
      }
    }
  },
  created() {
    this.getData()
    getGroupInfoByUser({ groupid: this.user.dGroupid }).then(response => {
      this.group = response.data
    })
    this.getFactoryList()
  },
  methods: {
    getFactoryList() {
      getFactoryList().then(response => {
        this.factoryList = response.data
      })
    },
    Search() {
      this.currentPage = 1
      this.getData()
      this.searchForm.search = this.searchForm.search.trim()
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid,
        userid: this.user.dUserid,
        role: this.user.role,
        type: this.searchForm.type,
        rktype: this.searchForm.rktype,
        factory: this.searchForm.factory
      }
      getErpPackList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleSelectionInfoChange(val) {
      this.multipleInfoSelection = val
    },
    openPackDetails(row) {
      if (row.bid === 3) {
        this.packTitle = row.ordernum + ' 包装列表'
      } else {
        this.packTitle = row.produnum + ' 包装列表'
      }
      this.editForm.orderid = row.orderid
      this.editForm.produnum = row.produnum
      this.editForm.packnum = ''
      this.editForm.xuhao = ''
      this.editForm.imark = ''
      this.editVisible = true
      this.searchPack()
    },
    openDetails(row) {
      this.packInfoTitle = row.produnum + ' 部件列表'
      this.editInfoForm.orderid = row.orderid
      this.editInfoForm.area = ''
      this.editInfoForm.type = ''
      this.editInfoForm.content = ''
      this.editInfoForm.packid = ''
      this.editInfoForm.mmark = ''
      this.editInfoForm.imark = ''
      this.isfirst = true
      this.areaList = []
      this.typeList = []
      this.packList = []
      this.editInfoVisible = true
      this.searchPackInfo()
    },
    searchPackInfo() {
      this.packInfoTableData = []
      this.multipleInfoSelection = []
      this.packInfoloading = true
      const data = {
        orderid: this.editInfoForm.orderid,
        area: this.editInfoForm.area,
        type: this.editInfoForm.type,
        content: this.editInfoForm.content,
        packid: this.editInfoForm.packid,
        mmark: this.editInfoForm.mmark,
        imark: this.editInfoForm.imark
      }
      getErpOrderPackInfoList(data).then(response => {
        this.tableInfoKey = new Date().getTime()
        this.packInfoTableData = response.data
        if (this.isfirst) {
          let areaList = []
          let typeList = []
          let packList = []
          for (let p of response.data) {
            let ishavearea = false
            for (let area of areaList) {
              if (area === p.area) {
                ishavearea = true
                break
              }
            }
            if (!ishavearea) {
              areaList.push(p.area)
            }
            let ishavetype = false
            for (let type of typeList) {
              if (type === p.type) {
                ishavetype = true
                break
              }
            }
            if (!ishavetype) {
              typeList.push(p.type)
            }
            if (p.packid !== null && p.packid !== '' && p.packid !== undefined) {
              let ishavepack = false
              for (let pack of packList) {
                if (pack.packid === p.packid) {
                  ishavepack = true
                  break
                }
              }
              if (!ishavepack) {
                packList.push({ packid: p.packid, packnum: p.packnum, packxuhao: p.packxuhao})
              }
            }
          }
          this.areaList = areaList
          this.typeList = typeList
          this.packList = packList
          this.isfirst = false
        }
        this.packInfoloading = false
      }).catch(() => {
        this.packInfoloading = false
      })
    },
    searchPack() {
      this.packTableData = []
      this.multipleSelection = []
      this.packloading = true
      const data = {
        orderid: this.editForm.orderid,
        packnum: this.editForm.packnum,
        xuhao: this.editForm.xuhao,
        imark: this.editForm.imark
      }
      getErpOrderPackList(data).then(response => {
        this.tableKey = new Date().getTime()
        this.packTableData = response.data
        this.packloading = false
      }).catch(() => {
        this.packloading = false
      })
    },
    checkboxInfoT(row, rowIndex) {
      if (row.imark === 1 || row.mmark === 0) {
        return false
      } else {
        return true
      }
    },
    checkboxT(row, rowIndex) {
      if (row.imark === 1) {
        return false
      } else {
        return true
      }
    },
    unpack(row) {
      if (row.packid !== null && row.packid !== '' && row.packid !== undefined) {
        this.subUnpack(row.packid)
      } else {
        this.$message.error('包标签号获取失败')
      }
    },
    unpackInfo(row) {
      if (row.obid !== null && row.obid !== '' && row.obid !== undefined) {
        this.subUnpackInfo(row.obid + '')
      } else {
        this.$message.error('部件ID获取失败')
      }
    },
    batchUnpack() {
      if (this.multipleSelection.length > 0) {
        let ids = []
        for (let m of this.multipleSelection) {
          if (m.packid !== null && m.packid !== '' && m.packid !== undefined) {
            ids.push(m.packid)
          }
        }
        if (ids.length > 0) {
          this.subUnpack(ids.join(','))
        } else {
          this.$message.error('未选中要入库的包装')
        }
      } else {
        this.$message.error('未选中要入库的包装')
      }
    },
    subUnpack(ids) {
      const arr = ids.split(',')
      this.$confirm('此操作将此 ' + arr.length + ' 个包装入库, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true
        const data = {
          packageIds: ids,
          userid: this.user.dUserid
        }
        packageInStock(data).then(response => {
          this.fullscreenLoading = false
          this.$message({
            message: '包装入库成功',
            type: 'success'
          })
          this.searchPack()
        }).catch(() => {
          this.fullscreenLoading = false
        })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.dblb-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
